<template>
  <ChipGeneric
    :item="computed_item"
    :key="'item_'+item.value"
    @update="chip_clicked"
  />
</template>
    
<script>  
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
  export default {
    name: 'DateRangeChip',
      
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
      
    components: {
      ChipGeneric,
    },
      
    computed: {
      computed_item() {
        return  {
                  readable: this.text,
                  readableValue: this.date_range,
                }
      },
      text() {
        return this.item.readable ||  'Rango de fechas';
      },
      date_range() {
        if (this.item.value && this.item.value.length > 0){
          return this.item.value[0]+' ~ '+this.item.value[1];
        } else {
          return null;
        }
      }
    },
      
    methods: {
      chip_clicked(){
        let new_item = this.item;
        new_item['selected'] = this.item.value;
        new_item['type'] = 'array';
        this.$emit('update',new_item);
      },
            
    },
  }
</script>